import * as React from 'react'

const Wheel5 = props => {
  const gradientColors = (
    <>
      <stop stopColor="#EFC261" />
      <stop offset="0.07" stopColor="#DDAA3E" />
      <stop offset="0.13" stopColor="#CE9722" />
      <stop offset="0.2" stopColor="#C4890F" />
      <stop offset="0.26" stopColor="#BE8103" />
      <stop offset="0.33" stopColor="#BC7F00" />
      <stop offset="0.55" stopColor="#F0D6A2" />
      <stop offset="0.66" stopColor="#F6E6C3" />
      <stop offset="0.8" stopColor="#E2CB9A" />
      <stop offset="0.92" stopColor="#CCA75B" />
    </>
  )
  return (
    <svg
      viewBox="0 0 42 59"
      ref={props.pointerRef}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6525 0.876953C9.97146 0.876953 1.31445 9.53615 1.31445 20.2172C1.31445 30.8983 10.0175 46.2364 20.6547 56.5232"
          fill="url(#paint0_linear_7794_19190)"
        />
        <g style={{ mixBlendMode: 'multiply' }} opacity="0.4">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.6525 0.876953C9.97146 0.876953 1.31445 9.53615 1.31445 20.2172C1.31445 30.8983 10.0175 46.2364 20.6547 56.5232"
            fill="#E8AC5A"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6523 0.876953C31.3334 0.876953 39.9926 9.53615 39.9926 20.2172C39.9926 30.8983 31.2896 46.2364 20.6523 56.5232"
          fill="url(#paint1_linear_7794_19190)"
        />
        <g style={{ mixBlendMode: 'multiply' }} opacity="0.3">
          <path
            d="M20.6525 0.876953C9.97146 0.876953 1.31445 9.53615 1.31445 20.2172C1.31445 30.8983 10.0175 46.2364 20.6547 56.5232"
            fill="#7C4F0B"
          />
          <path
            d="M20.6525 0.876953C9.97146 0.876953 1.31445 9.53615 1.31445 20.2172C1.31445 30.8983 10.0175 46.2364 20.6547 56.5232"
            fill="#7C4F0B"
          />
          <path
            d="M20.6525 0.876953C9.97146 0.876953 1.31445 9.53615 1.31445 20.2172C1.31445 30.8983 10.0175 46.2364 20.6547 56.5232"
            fill="#7C4F0B"
          />
          <path
            d="M20.6523 0.876953C31.3334 0.876953 39.9926 9.53615 39.9926 20.2172C39.9926 30.8983 31.2896 46.2364 20.6523 56.5232"
            fill="#7C4F0B"
          />
        </g>
        <g filter="url(#filter1_d_7794_19190)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.6522 2.19141C10.4749 2.19141 2.22754 10.441 2.22754 20.616C2.22754 30.7911 10.5209 45.4063 20.6522 55.2068C30.7856 45.4063 39.0768 30.7911 39.0768 20.616C39.0768 10.441 30.8294 2.19141 20.6522 2.19141Z"
            fill="url(#paint2_linear_7794_19190)"
          />
        </g>
        <g filter="url(#filter2_d_7794_19190)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.6523 2.19141C30.8274 2.19141 39.077 10.441 39.077 20.616C39.077 30.7911 30.7836 45.4063 20.6523 55.2068V2.19141Z"
            fill="url(#paint3_linear_7794_19190)"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.652 46.6699C13.3422 38.0808 8.06738 27.4238 8.06738 20.6178C8.06738 13.8118 13.7124 8.0332 20.652 8.0332C27.5916 8.0332 33.2367 13.6782 33.2367 20.6178C33.2367 27.5575 27.9618 38.0808 20.652 46.6699Z"
          fill="url(#paint4_linear_7794_19190)"
        />
        <g filter="url(#filter3_d_7794_19190)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.6528 45.536C13.6453 37.0761 8.7998 26.9274 8.7998 20.6186C8.7998 14.3099 14.1184 8.76562 20.6528 8.76562C27.1872 8.76562 32.5058 14.0821 32.5058 20.6186C32.5058 27.1552 27.6603 37.0761 20.6528 45.536Z"
            fill="url(#paint5_linear_7794_19190)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_7794_19190"
          x="0.000130415"
          y="0.000737965"
          width="41.3064"
          height="58.2751"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.438108" />
          <feGaussianBlur stdDeviation="0.657161" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7794_19190"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7794_19190"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_7794_19190"
          x="1.4959"
          y="1.45977"
          width="38.3129"
          height="54.4789"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.36582" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.737255 0 0 0 0 0.541176 0 0 0 0 0.176471 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7794_19190"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7794_19190"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_7794_19190"
          x="19.9207"
          y="1.45977"
          width="19.8881"
          height="54.4789"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.36582" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.737255 0 0 0 0 0.541176 0 0 0 0 0.176471 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7794_19190"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7794_19190"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_7794_19190"
          x="8.06817"
          y="8.03399"
          width="25.1693"
          height="38.2328"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.36582" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.737255 0 0 0 0 0.541176 0 0 0 0 0.176471 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7794_19190"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7794_19190"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_7794_19190"
          x1="10.9835"
          y1="56.5232"
          x2="10.9835"
          y2="0.876953"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F0C362" />
          <stop offset="0.86" stopColor="#EFDFBD" />
          <stop offset="1" stopColor="#CCA75B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7794_19190"
          x1="30.3236"
          y1="56.5232"
          x2="30.3236"
          y2="0.876953"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F0C362" />
          <stop offset="0.86" stopColor="#EFDFBD" />
          <stop offset="1" stopColor="#CCA75B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_7794_19190"
          x1="21.0333"
          y1="45.7678"
          x2="21.0333"
          y2="-7.24762"
          gradientUnits="userSpaceOnUse">
          {gradientColors}
        </linearGradient>
        <linearGradient
          id="paint3_linear_7794_19190"
          x1="30.2469"
          y1="45.7678"
          x2="30.2469"
          y2="-7.24762"
          gradientUnits="userSpaceOnUse">
          {gradientColors}
        </linearGradient>
        <linearGradient
          id="paint4_linear_7794_19190"
          x1="30.1305"
          y1="25.4589"
          x2="2.91524"
          y2="-8.14831"
          gradientUnits="userSpaceOnUse">
          <stop offset="0.1" stopColor="#EFD394" />
          <stop offset="0.31" stopColor="#E4C073" />
          <stop offset="0.48" stopColor="#DEB45D" />
          <stop offset="0.56" stopColor="#CCA046" />
          <stop offset="0.65" stopColor="#BE9033" />
          <stop offset="0.71" stopColor="#B98B2D" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_7794_19190"
          x1="21.034"
          y1="36.0948"
          x2="21.034"
          y2="-0.675593"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#EFC261" />
          <stop offset="0.05" stopColor="#DDAA3E" />
          <stop offset="0.09" stopColor="#CE9722" />
          <stop offset="0.14" stopColor="#C4890F" />
          <stop offset="0.18" stopColor="#BE8103" />
          <stop offset="0.23" stopColor="#BC7F00" />
          <stop offset="0.29" stopColor="#C89428" />
          <stop offset="0.38" stopColor="#D8B15F" />
          <stop offset="0.45" stopColor="#E5C88A" />
          <stop offset="0.52" stopColor="#EED8A9" />
          <stop offset="0.58" stopColor="#F3E2BC" />
          <stop offset="0.63" stopColor="#F6E6C3" />
          <stop offset="0.84" stopColor="#E2CB9A" />
          <stop offset="0.96" stopColor="#CCA75B" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Wheel5
